<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="sugar_page.list_title" />

    <SugarList
      :sugars="filteredSugars"
      :stats="stats"
      :loading="loading"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deleteSugar"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreateSugarModal
      :open="showModal"
      :is-edit="!!selectedSugar"
      :form="form"
      :errors="errors"
      :loading="loading"
      @close="closeModal"
      @save="saveSugar"
      @generate-code="generateSugarCode"
      @update-field="updateField"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateSugarModal from "../../components/Settings/SugarList/CreateSugarModal.vue";
import SugarList from "../../components/Settings/SugarList/SugarList.vue";
import { useSugar } from "../../composables/useSugar";

const {
  searchQuery,
  filteredSugars,
  stats,
  showModal,
  selectedSugar,
  form,
  errors,
  loading,
  paginationConfig,
  fetchSugars,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  generateSugarCode,
  saveSugar,
  deleteSugar,
} = useSugar();

onMounted(fetchSugars);
</script>
